// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const FlowIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="FlowIcon" ref={forwardedRef} {...props}>
      <path d="M15.25 2a2.748 2.748 0 0 1 .379 5.47v2.038a1.25 1.25 0 0 1-1.25 1.25H5.75v1.932c-.013-.006.013.004 0 0 .814.303 1.405.966 1.644 1.81h7.697l-1.453-1.455L14.682 12l3.18 3.184-3.18 3.18-1.044-1.045L14.957 16H7.394A2.749 2.749 0 0 1 2 15.25c0-1.365.946-2.488 2.25-2.703-.017.003.016-.003 0 0v-2.04a1.25 1.25 0 0 1 1.25-1.25h8.629V7.26a2.75 2.75 0 0 1-1.439-1.51H7.31a2.748 2.748 0 0 1-5.31-1 2.75 2.75 0 0 1 5.452-.5h5.096A2.75 2.75 0 0 1 15.25 2M4.75 14a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m0-10.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m10.5 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const FlowIcon = /* @__PURE__ */ Object.assign(FlowIconComponent, {
  displayName: 'FlowIcon',
});
